<template>
  <el-dropdown split-button type="primary" @command="handleCommand" @click="print">
    打印 {{activeItem.templateName}}
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item :command="item.id" v-for="(item,index) in templateList" :key="item.id">{{item.templateName}}</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>
import {print} from './index.js'
export default {
  name: "printButton",
  props:{
    item:{
      type:Array,
      default:()=>[]
    },
    templateList:{
      type:Array,
      default:()=>[]
    }
  },
  data() {
    return {
      activeItem:{templateName:''},
      list:[
        {name:'模版一',id:1}
      ]
    };
  },
  methods:{
    handleCommand(key){
      this.activeItem=this.templateList.filter((item)=>{
        return key==item.id
      })[0]
    },
    print(){
      if(!this.activeItem.id){
        this.$message.warning('请选择模版！')
        return;
      }
      print(JSON.parse(this.activeItem.templateJson),[{pkgCode:99348723897649234}])
    }
  }
};
</script>
